export default "__VITE_ASSET__BUrA_0t3__"